//
// ─── Polyfills IMPORTS ─────────────────────────────────────────────────────────────
//
import addPolyFills from './addPolyfills'

//
// ─── VENDOR IMPORTS ─────────────────────────────────────────────────────────────
//

import React from 'react'
import { render } from 'react-dom'
import TagManager from 'react-gtm-module'

//
// ─── REGULAR IMPORTS ────────────────────────────────────────────────────────────
//

import App from './App'
import { loginIfPrevAuthFound } from './stores/mainStore'
import settings from './settings'
import axiosConfig from './api/axiosConfig'
import AppProvider from './context/appProvider'
import { setupLogger } from './services/logger'

//
// ─── STYLES IMPORTS ─────────────────────────────────────────────────────────────
//

// direction in-sensitive css
import './styles/reset.css'

const { isRtl, gtmId, DEV_MODE } = settings

// direct sensitive css
if (isRtl) {
  import('./styles/index.rtl.css')
  import('./styles/form-fields-global.rtl.css')
} else {
  import('./styles/index.ltr.css')
  import('./styles/form-fields-global.ltr.css')
}

//
// ─── INITIAL SETUP ──────────────────────────────────────────────────────────────
//
addPolyFills()

axiosConfig()
loginIfPrevAuthFound()

//
// ─── LOGGER  ──────────────────────────────────────────────────────────────
//

if (!DEV_MODE) {
  setupLogger()
}

//
// ─── INITIAL GOOGLE TAG MANAGER  ──────────────────────────────────────────────────────────────
//

if (gtmId) {
  const tagManagerArgs = {
    gtmId: gtmId.trim(),
    events: {
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    },
  }

  TagManager.initialize(tagManagerArgs)
}

//
// ─── RENDER ─────────────────────────────────────────────────────────────────────
//

render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

//
// ─── REGISTER SERVICE WORKER ────────────────────────────────────────────────────
//

// remove service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister()
  })
}
